export default function (campaign, config) {
  const {
    alwaysOn,
    brands,
    ccdbReportEnabled,
    ccdbReportType,
    channelPriority,
    contentClassification,
    contributionType,
    description,
    disableOrchestration,
    endDate,
    finality,
    manager,
    marketCodes,
    masterKey,
    name,
    onlyHeader,
    preview,
    recordType,
    segmentType,
    startDate,
    status,
    touchpoint,
    type
  } = campaign

  return {
    alwaysOn,
    brands,
    ccdbReportEnabled,
    ccdbReportType,
    channelPriority: channelPriority || null,
    contentClassification: contentClassification || null,
    contributionType: contributionType || null,
    description,
    disableOrchestration,
    endDate: endDate || null,
    finality,
    manager,
    marketCodes,
    masterKey,
    name,
    onlyHeader,
    preview,
    recordType,
    segmentType,
    startDate: startDate || null,
    status,
    touchpoint,
    type,
    config: _buildConfig(campaign, config)
  }
}

function _buildConfig (campaign, config) {
  const configObject = {}
  if (campaign.config.campaignData) {
    configObject.campaignData = campaign.config.campaignData
  }

  return configObject
}
